import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useSwipeable } from 'react-swipeable';
import Button from '@mui/material/Button';
import { useRef, useState } from 'react';

function PlayerRow({ player, onEnter, onExit, onStatChange }) {
    const rowRef = useRef(null);
    const [swipeClass, setSwipeClass] = useState('');
    // Calculate total played ms from sessions
    let playedMs = 0;
    let onField = false;
    player.sessions.forEach((s) => {
        if (s.exit) {
            playedMs += s.exit - s.enter;
        } else {
            playedMs += Date.now() - s.enter;
            onField = true;
        }
    });
    const minutes = Math.floor(playedMs / 60000);
    const seconds = Math.floor((playedMs % 60000) / 1000);

    const handleSwipeAnimation = (eventData) => {
        console.log(eventData);
        if (eventData.dir === 'Left') {
            
            setSwipeClass('swipe-left');
            setTimeout(() => setSwipeClass(''), 300); // Remove class after animation
        } else if (eventData.dir === 'Right') {
            setSwipeClass('swipe-right');
            setTimeout(() => setSwipeClass(''), 300); // Remove class after animation
        }
    };

    const handlers = useSwipeable({
        onSwipedLeft: () => onExit(player.id),
        onSwipedRight: () => onEnter(player.id),
        onSwipeStart: (eventData) => handleSwipeAnimation(eventData),
        preventScrollOnSwipe: true,
        trackMouse: true
    });

    return (
        <TableRow
            ref={rowRef}
            className={swipeClass}
            selected={onField}
            {...handlers}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
        >
            <TableCell component="th" scope="row">{player.name}</TableCell>
            <TableCell>{minutes}:{seconds.toString().padStart(2, '0')}</TableCell>
            <TableCell>
                <Button variant="contained" onClick={() => onStatChange(player.id, 'passes', player.passes + 1)} disabled={!onField}>{player.passes}</Button>
            </TableCell>
            <TableCell>
                <Button variant="contained" onClick={() => onStatChange(player.id, 'shots', player.shots + 1)} disabled={!onField}>
                    {player.shots}
                </Button>
            </TableCell>
            <TableCell>
                <Button variant="contained" onClick={() => onStatChange(player.id, 'goals', player.goals + 1)} disabled={!onField}>
                    {player.goals}
                </Button>
            </TableCell>
        </TableRow>
    );
}

export default PlayerRow;
